import React from "react";
import { useNavigate } from "react-router-dom";
import {
  RankingMetaColetivaProvider,
  useRankingMetaColetiva,
} from "./context/RankingMetaColetivaContext";
import { RankingMetaColetivaView } from "./components/RankingMetaColetivaView";

const RankingMetaColetivaContent: React.FC = () => {
  const navigate = useNavigate();
  const {
    metaColetiva,
    lojas,
    isLoading,
    selectedLojaId,
    showLojaSelector,
    selectedLojaNome,
    metasCount,
    startDate,
    endDate,
    toggleLojaSelector,
    selectAllLojas,
    selectLoja,
    setStartDate,
    setEndDate,
    applyFilter,
  } = useRankingMetaColetiva();

  if (isLoading) {
    return (
      <div className="relative flex h-screen items-center justify-center overflow-hidden bg-slate-900 text-white">
        <div className="text-center">
          <p className="text-xl">Carregando meta coletiva...</p>
        </div>
      </div>
    );
  }

  return (
    <RankingMetaColetivaView
      metaColetiva={metaColetiva}
      lojas={lojas}
      selectedLojaId={selectedLojaId}
      showLojaSelector={showLojaSelector}
      selectedLojaNome={selectedLojaNome}
      metasCount={metasCount}
      startDate={startDate}
      endDate={endDate}
      onGoHome={() => navigate("/dashboard")}
      onToggleLojaSelector={toggleLojaSelector}
      onSelectAllLojas={selectAllLojas}
      onSelectLoja={selectLoja}
      onStartDateChange={setStartDate}
      onEndDateChange={setEndDate}
      onApplyFilter={applyFilter}
    />
  );
};

const RankingMetaColetivaPage: React.FC = () => {
  return (
    <RankingMetaColetivaProvider>
      <RankingMetaColetivaContent />
    </RankingMetaColetivaProvider>
  );
};

export default RankingMetaColetivaPage;
export { RankingMetaColetivaView } from "./components/RankingMetaColetivaView";
export type { RankingMetaColetivaViewProps } from "./types";
